const PropTypes = require("prop-types");
// @vendor
const React = require("react");
//@commons
const { formatText, FormattedText } = require("core/i18n").i18n;
const { InputSafe } = require("commonsComponents/inputSafe");
const { OKMessage } = require("commonsComponents/OKMessage");
const { RadioButton } = require("commonsComponents/radioButton");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");

// @ helpers
const {
    getPhoneCodeFromOriginCountry,
    isValidPhoneNumber,
    getMaskedPhone,
    getEmail
} = require("utilities/personalDataHelper");
// @ Utilities
const { validateCellPhone } = require("commonsUtilities/validations");
const {
    updatePhoneFormatByCountry
} = require("commonsUtilities/phoneNumberUtils");
// @constants
const {
    PROFILE_EDITOR_UPDATE_OTP_ON_SMS,
    PROFILE_EDITOR_UPDATE_OTP_ON_EMAIL
} = require("constants/index");
class EditPhoneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionTypeSelectedValue: PROFILE_EDITOR_UPDATE_OTP_ON_SMS
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    componentDidUpdate() {
        const { actionChangeValue } = this.props;
        actionChangeValue({
            otpBySmsOrEmail: this.state.optionTypeSelectedValue
        });
    }

    buildFormOTP() {
        const { immProfileEditor, immProfileFields } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const phoneCode = getPhoneCodeFromOriginCountry(
            immProfileFields.get("originCountry")
        );
        const contactNumber = immProfileFields.getIn([
            "telefonoContacto",
            "numero"
        ]);
        const originCountry = immProfileFields.get("originCountry");
        const maskedPhone = getMaskedPhone(
            phoneCode + contactNumber,
            originCountry
        );
        const currentEmail = getEmail(immProfileFields);
        const phoneNumber = (
            <FormattedText
                value="profileEditPhoneNumber-otpBySms"
                injectedStrings={[maskedPhone]}
            />
        );
        const email = (
            <FormattedText
                value="profileEditPhoneNumber-otpByEmail"
                injectedStrings={[currentEmail]}
            />
        );
        const hasEmail = immStep.get("email").trim() !== "";

        return (
            <div className="edit-form-step__otp-options-wrapper">
                <div className="edit-form-step__message-warning">
                    <OKMessage type="important">
                        <FormattedText value="profile-OTPHeader" />
                    </OKMessage>
                </div>
                <section className="edit-form-step__otp-options">
                    <header className="edit-form-step__form-label">
                        <FormattedText value="profile-Confirmations" />
                    </header>
                    <RadioButtonGroup
                        name="profile-otp-filter"
                        idPrefix="profile-otp-filter-radio"
                        selectedValue={this.state.optionTypeSelectedValue}
                        onChange={this.handleOptionChange}
                        className="edit-form-step__options edit-form-step__options--otp-options"
                    >
                        <RadioButton
                            className="edit-form-step__radio-option"
                            label={phoneNumber}
                            value={PROFILE_EDITOR_UPDATE_OTP_ON_SMS}
                        />
                        <RadioButton
                            className="edit-form-step__radio-option"
                            label={email}
                            value={PROFILE_EDITOR_UPDATE_OTP_ON_EMAIL}
                            disabled={!hasEmail}
                        />
                    </RadioButtonGroup>
                    {!hasEmail && (
                        <FormattedText value="profileEditForm-emptyEmail" />
                    )}
                    <div className="edit-form-step__call-us-text">
                        <FormattedText value="profile-ContactBank" />
                    </div>
                    <div className="edit-form-step__initial-modal-phones-container">
                        <i className="icon-s-llamar edit-form-step__initial-modal-phone-icon"></i>
                        <FormattedText value="profile-phoneNumberClients" />
                    </div>
                </section>
            </div>
        );
    }

    buildRepeatPhoneSection() {
        const {
            getValidation,
            immProfileEditor,
            immProfileFields
        } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const phoneNumber = immStep.get("phoneNumber");
        const originCountry = immProfileFields.get("originCountry");
        const phoneCode = getPhoneCodeFromOriginCountry(originCountry);
        const repeatPhoneNumber = immStep.get("repeatPhoneNumber");
        const repeatPhoneNumberBlur = immStep.get("repeatPhoneNumberBlur");
        const repeatPhoneNumberIsValid = phoneNumber === repeatPhoneNumber;
        const disableField = !isValidPhoneNumber(phoneNumber, originCountry);
        const { repeatPhoneErrorState, repeatPhoneErrorMsg } = getValidation(
            "repeatPhone",
            repeatPhoneNumber,
            repeatPhoneNumberBlur,
            repeatPhoneNumberIsValid
        );

        return (
            <div className="col-xs-6">
                <p className="edit-form-step__form-label">
                    <FormattedText value="profileEditForm-newPhoneRepeat" />
                </p>
                <div className="row">
                    <div className="col-xs-3">
                        <div className="edit-form-step__phone-code">
                            <InputSafe
                                disabled={true}
                                name="repeatPhoneCode"
                                type="text"
                                value={`+${phoneCode}`}
                            />
                        </div>
                    </div>
                    <div className="col-xs-9">
                        <InputSafe
                            name="repeatPhoneNumber"
                            onBlur={this.handleOnBlur}
                            onChange={this.handleInputChange}
                            type="text"
                            value={repeatPhoneNumber}
                            errorState={!disableField && repeatPhoneErrorState}
                            errorMessage={formatText(
                                `profile-${repeatPhoneErrorMsg}RepeatPhoneNumber`
                            )}
                            disabled={disableField}
                        />
                    </div>
                </div>
            </div>
        );
    }

    handleInputChange(event) {
        const { actionChangeValue, immProfileEditor } = this.props;
        const repeatPhoneNumber = immProfileEditor.getIn([
            "steps",
            0,
            "repeatPhoneNumber"
        ]);
        const { name } = event.target;
        let { value } = event.target;
        let newProps;
        newProps = {
            [name]: value,
            [`${name}Dirty`]: !!value,
            phoneNumberBlur: false,
            repeatPhoneNumberBlur: false
        };
        if (name === "phoneNumber" && repeatPhoneNumber) {
            newProps.repeatPhoneNumber = "";
        }
        actionChangeValue(newProps);
    }

    handleOptionChange(value) {
        this.setState({
            optionTypeSelectedValue: value
        });
    }

    handleOnBlur = evt => {
        const { handleBlur, immProfileFields } = this.props;
        const originCountry = immProfileFields.get("originCountry");
        if (evt.target.value) {
            evt.target.value = updatePhoneFormatByCountry(
                evt.target.value,
                originCountry
            );
        }
        handleBlur(evt);
    };

    render() {
        const {
            getValidation,
            immProfileEditor,
            immProfileFields
        } = this.props;
        const immStep = immProfileEditor.getIn(["steps", 0]);
        const phoneNumber = immStep.get("phoneNumber");
        const phoneNumberInitial = immStep.get("phoneNumberInitial");
        const phoneNumberValue = phoneNumber === phoneNumberInitial ? "" : phoneNumber;
        const originCountry = immProfileFields.get("originCountry");
        const phoneCode = getPhoneCodeFromOriginCountry(originCountry);
        const phoneNumberBlur = immStep.get("phoneNumberBlur");
        const contactNumber = immProfileFields.getIn([
            "telefonoContacto",
            "numero"
        ]);
        const maskedPhone = getMaskedPhone(
            phoneCode + contactNumber,
            originCountry
        );
        const phoneNumberIsValid =
            !phoneNumber || validateCellPhone(phoneNumber, originCountry);

        const { phoneErrorState, phoneErrorMsg } = getValidation(
            "phone",
            phoneNumber,
            phoneNumberBlur,
            phoneNumberIsValid
        );

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 edit-form-step__current-data">
                        <FormattedText
                            value="profileEditForm-currentPhone"
                            className="edit-form-step__form-label edit-form-step__form-label--data-title"
                        />
                    </div>
                    <div className="col-xs-12 edit-form-step__current-data-value">
                        {maskedPhone}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <p className="edit-form-step__form-label">
                            <FormattedText value="profileEditForm-newPhone" />
                        </p>
                        <div className="row">
                            <div className="col-xs-3 edit-form-step__min-height-field">
                                <div className="edit-form-step__phone-code">
                                    <InputSafe
                                        disabled={true}
                                        name="phoneCode"
                                        type="text"
                                        value={`+${phoneCode}`}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-9 edit-form-step__min-height-field">
                                <InputSafe
                                    name="phoneNumber"
                                    onBlur={this.handleOnBlur}
                                    onChange={this.handleInputChange}
                                    type="text"
                                    value={phoneNumberValue}
                                    errorState={phoneErrorState}
                                    errorMessage={formatText(
                                        `profile-${phoneErrorMsg}Number`
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    {this.buildRepeatPhoneSection()}
                </div>
                {this.buildFormOTP()}
            </div>
        );
    }
}

EditPhoneForm.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    getValidation: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immProfile: PropTypes.object
};

module.exports = EditPhoneForm;
